import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Collapse } from "react-collapse";
import { primaryColor, secondaryColor } from "../../../../Constants/Colors";
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { LuArrowUpRight } from "react-icons/lu";
import { faqData } from "../../../../Constants/content";


const FAQ = () => {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Container className="faq-container my-5">
      <Row>
        <Col md={5} className="p-xl-5 pt-xl-0 p-2 p-md-3 pt-0 ">
          <div className="d-flex align-items-center mb-2">
            <small className="text-muted text-uppercase me-3">FAQ</small>
            <div
              style={{ flex: 1, height: "2px", backgroundColor: "#ccc" }}
            ></div>
          </div>
          <h1
          className=""
            style={{
              color: primaryColor,
            }}
          >
            What Clients Usually Ask Us
          </h1>
          <p className="text-muted text-justify">
            Have questions? We've got answers. Explore some of the most common
            queries about our services, process, and how Ideal helps businesses
            grow with digital confidence.
          </p>
          <div className="p-4 ms-0 me-2 me-md-2 me-xl-4 d-none d-md-block" style={{
            border:`2px solid ${primaryColor}`,
            borderRadius: "10px",
          }}>
            <h6>Still have questions?</h6>
            <p className="text-justify">
              Can’t find the answer you’re looking for? Please connect to our
              friendly team.
            </p>
            <Button
              variant="rounded-5 "
              onClick={() => navigate("/contactUs")}
              className="d-flex align-items-center fw-bold w-100 justify-content-center"
              style={{ backgroundColor: secondaryColor }}
            >
              Contact Us
              <LuArrowUpRight className="ms-2 fs-4" />
            </Button>
          </div>
        </Col>
        <Col md={7}>
          {faqData.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                style={{
                  border: isOpen ? "2px solid transparent" : "2px solid #ccc",
                  borderRadius: "8px",
                  marginBottom: "1rem",
                  padding: "1rem",
                  background: isOpen
                    ? "linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, #007bff,rgb(106, 228, 95),rgb(223, 221, 107)) border-box"
                    : "#fff",
                  transition:
                    "border 0.4s ease, box-shadow 0.3s, background 0.4s ease",
                }}
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "1.1rem",
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "left",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 0,
                  }}
                >
                  <span>{faq.question}</span>
                  <span
                    style={{
                      fontSize: "1.5rem",
                      transition: "transform 0.3s ease",
                      color: primaryColor,
                    }}
                  >
                    {isOpen ? (
                      <AiOutlineMinusCircle />
                    ) : (
                      <AiOutlinePlusCircle />
                    )}
                  </span>
                </button>

                <Collapse isOpened={isOpen}>
                  <div
                    style={{
                      overflow: "hidden",
                      transition: "all 0.4s ease",
                      maxHeight: isOpen ? "500px" : "0",
                      opacity: isOpen ? 1 : 0,
                      marginTop: isOpen ? "0.5rem" : "0",
                      paddingTop: isOpen ? "0.5rem" : "0",
                      color: "#555",
                    }}
                  >
                    {faq.answer}
                  </div>
                </Collapse>
              </div>
            );
          })}
           <div className="p-4 ms-0 me-2 me-md-2 me-xl-4 d-block d-md-none" style={{
            border:`2px solid ${primaryColor}`,
            borderRadius: "10px",
          }}>
            <h6>Still have questions?</h6>
            <p className="text-justify">
              Can’t find the answer you’re looking for? Please connect to our
              friendly team.
            </p>
            <Button
              variant="rounded-5"
              onClick={() => navigate("/contactUs")}
              className="d-flex align-items-center fw-bold"
              style={{ backgroundColor: secondaryColor }}
            >
              Contact Us
              <LuArrowUpRight className="ms-2 fs-4" />
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default FAQ;
